import {useDebugValue} from 'react';

import classNames from 'classnames';

const classNamespace = 'search-form';
const iconClassName = `${classNamespace}__icon`;
const smallIconClassName = `${classNamespace}__small-icon`;
const largeIconClassName = `${classNamespace}__large-icon`;

function useComponent(props) {
    const {
        name,
        size
    } = props;

    const iconNameClassName = `${iconClassName}--${name}`;
    const iconSizeClassName = `${iconClassName}--${size}`;

    const className = classNames(iconClassName, iconSizeClassName, iconNameClassName);

    const showSmallIcon = size === 'small' || size === 'auto';
    const showLargeIcon = size === 'large' || size === 'auto';

    const iconMarkupId = `${name}`.toUpperCase().replace('-', '_');

    const smallIconMarkupId = `${iconMarkupId}__16`;
    const largeIconMarkupId = `${iconMarkupId}__24`;

    const {
        [smallIconMarkupId]: smallIconMarkup,
        [largeIconMarkupId]: largeIconMarkup
    } = require('@homeaway/svg-defs');

    const result = {
        className,
        showSmallIcon,
        showLargeIcon,
        smallIconClassName,
        largeIconClassName,
        smallIconMarkup,
        largeIconMarkup
    };

    useDebugValue(result);

    return result;
}

export {useComponent};
